'use client';

import { useTranslations } from 'next-intl';
import { Clock } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface AwaitingPaymentScreenProps {
  email: string | null;
}

/**
 * Shown when the payment outcome can't be confirmed client-side (settlement
 * poll timed out, or completion failed after a confirmed payment). The
 * webhook completes the registration server-side and the confirmation email
 * follows — the donor's spot is held either way.
 */
export function AwaitingPaymentScreen({ email }: AwaitingPaymentScreenProps) {
  const t = useTranslations('register');

  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-6">
      <div className="flex flex-col items-center gap-4 py-6 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-amber-500/20">
          <Clock className="h-7 w-7 text-amber-600" />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">{t('awaitingPaymentTitle')}</h1>
          <p className="text-muted-foreground">{t('awaitingPaymentBody')}</p>
          {email && (
            <p className="text-sm text-muted-foreground">{t('awaitingPaymentEmail', { email })}</p>
          )}
        </div>
        <Button
          type="button"
          onClick={() => window.location.assign('/my/dashboard')}
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          {t('goToDashboard')}
        </Button>
      </div>
    </div>
  );
}
